import { isNullOrWhitespace } from ".";
import { IBwjColor } from "../entities/bwj-color";

function normalizeHexRgbString(value: string | null | undefined): string | undefined {
    if(isNullOrWhitespace(value)) { return; }
    let v = (value as string).toLowerCase().trim();
    if(/^#?[0-9a-f]{3,8}$/.test(v) === false) { return; }
    if(v[0] === '#') {
        v = v.substring(1);
    }
    if(v.length === 5 || v.length === 7) { return; } // only two lengths not allowed

    if(v.length === 3) { return `${v[0]}${v[0]}${v[1]}${v[1]}${v[2]}${v[2]}ff`; }
    if(v.length === 4) { return `${v[0]}${v[0]}${v[1]}${v[1]}${v[2]}${v[2]}${v[3]}${v[3]}`; }
    if(v.length === 6) { return `${v}ff`; }
    return v; // full 8 char RGBA format
}

export function parseHexString(value: string): number {
    return parseInt(value, 16);
}

export function toColor(value: string | null | undefined): IBwjColor | undefined {
    const v = normalizeHexRgbString(value);
    if(!v) { return; }

    return {
        red: parseHexString(v.substring(0, 2)),
        green: parseHexString(v.substring(2, 4)),
        blue: parseHexString(v.substring(4, 6)),
        alpha: parseHexString(v.substring(6)),
    };
}

export function toRgbaFunctionString(color: IBwjColor | null | undefined): string | undefined {
    if(!color) { return; }

    const alpha = color.alpha * (1 / 255);
    return `rgba(${color.red}, ${color.green}, ${color.blue}, ${alpha})`;
}

export function hexToRgbaFunctionString(hexadecimalValue: string): string | undefined {
    const color = toColor(hexadecimalValue);
    return toRgbaFunctionString(color);
}